import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'presence.rovo-name.non-final': {
    id: 'presence.rovo-name.non-final',
    defaultMessage: 'Rovo',
    description:
      'The accessible display name for an AI agent in the database collaborator facepile.'
  }
});
